<template>
    <div class="cookies-page">
        <div class="page-content">
            <div class="card">
                <div class="card-header">
                    <h1>
                        <font-awesome-icon icon="fad fa-cookie-bite" class="me-1"/>
                        Cookie policy
                    </h1>
                    <h6>
                        To make this site work properly, we sometimes place
                        small data files called cookies on your device. Most big
                        websites do this too.
                    </h6>
                </div>
                <div class="card-body">
                    <section>
                        <h3>What are cookies?</h3>
                        <p>
                            A cookie is a small text file that a website saves
                            on your computer or mobile device when you visit the
                            site. It enables the website to remember your
                            actions and preferences (such as login, language,
                            font size and other display preferences) over a
                            period of time, so you don't have to keep
                            re-entering them whenever you come back to the site
                            or browse from one page to another.
                        </p>
                    </section>
                    <hr />
                    <section>
                        <h3>How do we use cookies?</h3>
                        <p>
                            We only use “first-party cookies”. These are cookies
                            set and controlled by the European institution, not
                            by any external organisation.
                        </p>
                        <div>
                            The 3 types of first-party cookie we use are to:
                            <ul>
                                <li>store visitor preferences</li>
                                <li>make our websites operational</li>
                                <li>
                                    gather analytics data (about user behaviour)
                                </li>
                            </ul>
                        </div>
                        <p>
                            The table below provides more information about the
                            cookies used on this website.
                        </p>
                        <table class="table">
                            <tbody>
                                <tr>
                                    <th>Name</th>
                                    <th>Service</th>
                                    <th>Purpose</th>
                                    <th>Cookie type and duration</th>
                                </tr>
                                <tr>
                                    <td>cck1</td>
                                    <td>Cookie consent kit</td>
                                    <td>
                                        Stores your cookie preferences (so you
                                        won't be asked again)
                                    </td>
                                    <td>
                                        First-party persistent cookie, 6 months
                                    </td>
                                </tr>
                                <tr>
                                    <td>AspNetCore.Session</td>
                                    <td>HR Forms</td>
                                    <td>
                                        Maintain a secure session for you,
                                        during your visit
                                    </td>
                                    <td>
                                        First-party session cookie, deleted
                                        after you quit your browser
                                    </td>
                                </tr>
                                <tr>
                                    <td>AspNetCore.Cookies</td>
                                    <td>HR Forms</td>
                                    <td>
                                        Manage cookies to store your
                                        preferences, during your visit
                                    </td>
                                    <td>
                                        First-party session cookie, deleted
                                        after you quit your browser
                                    </td>
                                </tr>
                                <tr>
                                    <td>Language</td>
                                    <td>HR Forms</td>
                                    <td>Stores your language preferences</td>
                                    <td>
                                        First-party persistent cookie, 1 year
                                    </td>
                                </tr>
                                <tr>
                                    <td>_pk_id#</td>
                                    <td>
                                        Web analytics service, based on Matomo
                                        open source software
                                    </td>
                                    <td>
                                        Recognises website visitors (<b
                                            >anonymously</b
                                        >
                                        - no personal information is collected
                                        on the user)
                                    </td>
                                    <td>
                                        First-party persistent cookie, 13 months
                                    </td>
                                </tr>
                                <tr>
                                    <td>_pk_ses#</td>
                                    <td>
                                        Web analytics service, based on Matomo
                                        open source software
                                    </td>
                                    <td>
                                        Identifies the pages viewed by the same
                                        user during the same visit (<b
                                            >anonymously</b
                                        >
                                        - no personal information is collected
                                        on the user)
                                    </td>
                                    <td>
                                        First-party persistent cookie, 30
                                        minutes
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </section>
                    <section>
                        <h3>How to control cookies</h3>
                        <p>
                            You can control and/or delete cookies as you wish -
                            for details, see
                            <a href="http://aboutcookies.org/" aria-label="aboutcookies.org">aboutcookies.org</a>. 
                            You can delete all cookies that are already on
                            your computer and you can set most browsers to
                            prevent them from being placed. If you do this,
                            however, you may have to manually adjust some
                            preferences every time you visit a site and some
                            services and functionalities may not work.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CookiesPage',
    components: {},
    data() {
        return {};
    },
};
</script>
